let $header;
let $menu;
let $menuToggle;
let $searchToggle;
let $copyUrl;
let $toggleSocialShare;
let $submenuOpen;
let $submenuClose;
let $toc;
let $tocOpen;
let $loginMenu;
let $overlay;
let $toggleMenu;

$(document).ready(($) => {
  // eslint-disable-next-line no-console
  console.log('%cLinku Novio', 'font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px');

  if (window.BdUserContent && typeof window.BdUserContent.initBdUserContent === 'function') {
    window.BdUserContent.initBdUserContent().catch(() => {});
  }

  $menu = $('.js-menu');
  $header = $('.js-header');
  $menuToggle = $('.js-menu-toggle');
  $searchToggle = $('.js-search-toggle');
  $submenuOpen = $('.js-submenu-open');
  $submenuClose = $('.js-submenu-close');
  $copyUrl = $('.js-copy-url');
  $toggleSocialShare = $('.js-toggle-social');
  $loginMenu = $('.js-is-login-menu');
  $overlay = $('.js-overlay');
  $toggleMenu = $('.js-toggle-menu');

  $toc = $('.js-toc');
  $tocOpen = $('.js-toc-open');

  // eslint-disable-next-line no-undef
  hljs.highlightAll();

  $tocOpen.on('click', () => {
    $toc.toggleClass('is-open');
  });

  // Toggle premium filter: update URL when changed
  $('.js-toggle-premium').on('change', 'input[type="checkbox"]', function () {
    const url = new URL(window.location.href);
    if ($(this).prop('checked')) {
      url.searchParams.set('show_premium', '1');
    } else {
      url.searchParams.delete('show_premium');
    }
    window.location.href = url.toString();
  });

  // TOC active state management
  initTocActiveState();

  initTocScroll();

  $menuToggle.on('click', (e) => {
    $menu.toggleClass('is-open');
    $header.toggleClass('is-open');
    $(this).toggleClass('is-open');
  });

  $searchToggle.on('click', (e) => {
    e.preventDefault();
    $header.toggleClass('has-open-search');
    $('body').toggleClass('has-open-search');
  });

  $toggleSocialShare.on('click', (e) => {
    e.preventDefault();
    $toggleSocialShare.toggleClass('is-visible');
  });

  $toggleMenu.on('click', function (e) {
    e.preventDefault(); // Prevents scrolling to top

    if ($(this).hasClass('is-open')) {
      $(this).removeClass('is-open');
      $menu.removeClass('is-open');
      $header.removeClass('s-header--mob-menu-is-open');
    } else {
      $(this).addClass('is-open');
      $menu.addClass('is-open');
      $loginMenu.removeClass('is-submenu-open');
      $overlay.removeClass('is-active');
      $header.addClass('s-header--mob-menu-is-open');
    }
  });

  $overlay.on('click', () => {
    $overlay.removeClass('is-active');
    $loginMenu.removeClass('is-submenu-open');
    $loginMenu.removeClass('is-open');
  });

  $submenuOpen.on('click', function (e) {
    if ($(this).parents('.js-is-login-menu').length === 0) {
      e.preventDefault(); // Prevents scrolling to top
    }

    if (!isMobile()) {
      if ($(this).parents('.js-is-login-menu').length === 0) {
        $(this).parents('.js-has-submenu').toggleClass('is-submenu-open');
        $overlay.addClass('is-active');
      }
    } else if ($(this).parents('.js-is-login-menu').length > 0) {
      if ($(this).parents('.js-is-login-menu').hasClass('is-logged-in')) {
        $(this).parents('.js-is-login-menu').toggleClass('is-submenu-open');
        $overlay.toggleClass('is-active');
      }
    } else {
      $(this).parents('.js-has-submenu').addClass('is-submenu-open');
    }
  });

  // Close submenus on escape key press
  $(document).keydown((e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      $('.js-has-submenu').removeClass('is-submenu-open');
    }
  });

  $submenuClose.on('click', function (e) {
    e.preventDefault(); // Prevents scrolling to top
    $(this).removeClass('is-submenu-open');
    $(this).parents('.js-has-submenu').removeClass('is-submenu-open');
  });

  // Copy current url
  $copyUrl.on('click', function (e) {
    e.preventDefault();
    const urlToCopy = $(this).attr('href');

    navigator.clipboard.writeText(urlToCopy).then(() => {
      const $messageElement = $('<span class="c-button__message js-button-message">Link gekopieerd</span>');
      $(this).append($messageElement);
      setTimeout(() => {
        $messageElement.addClass('is-visible');
      }, 100);

      setTimeout(() => {
        $messageElement.removeClass('is-visible');
      }, 2700);

      setTimeout(() => {
        $messageElement.remove();
      }, 3000);
    });
  });

  // This variable is magically declined globally from another file (Accordion.js)
  // eslint-disable-next-line no-undef
  const accordion = new Accordion(
    '.js-accordion',
    '.js-toggle-accordion',
    '.js-accordion-content',
  );

  accordion.initClickHandling();

  // Initialize syntax highlighting for Gutenberg core/code blocks
  if (typeof window.hljs !== 'undefined' && typeof window.hljs.highlightAll === 'function') {
    window.hljs.highlightAll();
  }
});

/**
 * Initialize TOC active state management using Intersection Observer
 * Adds 'is-active' class to TOC items when their corresponding heading is in view
 */
function initTocActiveState() {
  const $tocItems = $('.js-toc-item');

  if ($tocItems.length === 0) {
    return;
  }

  // Create an array of heading elements and their corresponding TOC items
  const headingElements = [];

  $tocItems.each(function () {
    const $tocItem = $(this);
    const $tocLink = $tocItem.find('.c-toc__link');
    const href = $tocLink.attr('href');

    if (href && href.startsWith('#')) {
      const id = href.substring(1);
      const $heading = $(`#${id}`);

      if ($heading.length > 0) {
        headingElements.push({
          element: $heading[0],
          tocItem: $tocItem,
          id,
        });
      }
    }
  });

  if (headingElements.length === 0) {
    return;
  }

  // Create a map to track which headings are currently intersecting
  const intersectingHeadings = new Map();

  // Track scroll direction for better active state management
  let lastScrollTop = $(window).scrollTop();
  let isScrollingUp = false;
  let isClickScrolling = false; // Flag to indicate scroll was triggered by TOC click

  // Update scroll direction on scroll
  $(window).on('scroll', () => {
    const currentScrollTop = $(window).scrollTop();
    isScrollingUp = currentScrollTop < lastScrollTop;
    lastScrollTop = currentScrollTop;
  });

  // Intersection Observer options - more balanced margins for consistent behavior
  const observerOptions = {
    root: null, // Use viewport as root
    rootMargin: '-50px 0px -30% 0px', // Smaller top margin, larger bottom margin for better balance
    threshold: 0, // Trigger as soon as any part of the element is visible
  };

  // Create the Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const headingId = entry.target.id;
      const headingData = headingElements.find((h) => h.id === headingId);

      if (headingData) {
        if (entry.isIntersecting) {
          intersectingHeadings.set(headingId, headingData);
        } else {
          intersectingHeadings.delete(headingId);
        }

        // Update active TOC item based on intersecting headings
        updateActiveTocItem();
      }
    });
  }, observerOptions);

  // Function to update active TOC item
  function updateActiveTocItem() {
    // Skip automatic updates if we're in the middle of a click-triggered scroll
    if (isClickScrolling) {
      return;
    }

    // Remove active class from all TOC items
    $tocItems.removeClass('is-active');

    if (intersectingHeadings.size > 0) {
      const intersectingArray = Array.from(intersectingHeadings.values());
      let activeHeading;

      if (isScrollingUp && intersectingArray.length > 1) {
        // When scrolling up with multiple intersecting headings, prefer the bottom-most one
        [activeHeading] = intersectingArray.slice(-1);
      } else {
        // When scrolling down or single heading, use the topmost intersecting heading
        [activeHeading] = intersectingArray;
      }

      activeHeading.tocItem.addClass('is-active');
    } else if (headingElements.length > 0) {
      // If no headings are intersecting, check if we're past the last heading
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const lastHeading = headingElements[headingElements.length - 1];
      const $lastHeading = $(lastHeading.element);
      const lastHeadingTop = $lastHeading.offset().top;

      // Only activate last heading if we're significantly past it
      if (scrollTop + windowHeight > lastHeadingTop + 200) {
        lastHeading.tocItem.addClass('is-active');
      }
    }
  }

  // Observe all heading elements
  headingElements.forEach((headingData) => {
    observer.observe(headingData.element);
  });

  // Add click handlers for TOC links to handle manual navigation
  $tocItems.each(function () {
    const $tocItem = $(this);
    const $tocLink = $tocItem.find('.c-toc__link');

    $tocLink.on('click', () => {
      // Set clicked item as active immediately
      $tocItems.removeClass('is-active');
      $tocItem.addClass('is-active');

      // Prevent automatic updates during click-triggered scroll
      isClickScrolling = true;

      // Re-enable automatic updates after scroll animation completes
      // Use a longer timeout to ensure smooth scrolling is complete
      setTimeout(() => {
        isClickScrolling = false;
      }, 1000);
    });
  });
}

function isMobile() {
  return window.matchMedia(`only screen and (max-width:${992}px)`).matches;
}

function initTocScroll() {
  const $tocContent = $toc.find('.c-toc__content-inner')[0];

  if ($tocContent) {
    if ($tocContent.scrollHeight > $tocContent.clientHeight) {
      $toc.addClass('is-scrollable');
    }
  }
}
